import { Injectable } from '@angular/core';
import { AppConfigSettings } from '@arc/arc-shared-frontend';

@Injectable({
  providedIn: 'root'
})
export class ConfigService {
  _wisUrl: any;
  _pacURI: any;
  _maintenanceMode: any;

  constructor(private appConfig: AppConfigSettings) {
    this._wisUrl = appConfig.getconfig('wisUrl');
    this._pacURI = appConfig.getconfig('pacURI');
    this._maintenanceMode = appConfig.getconfig('maintenanceMode');
  }

  GetWISUrl() {
    return this._wisUrl;
  }
  GetPacURI() {
    return this._pacURI;
  }
  GetMaintenanceMode() {
    return this._maintenanceMode;
  }
}
